module.exports = __webpack_public_path__ + "img/hemline sweep.81aefcb1.png";